export type SummitTourLocationState = {
  showSummitTour?: boolean;
  showTakeATourTip?: boolean;
};

export const SHOW_SUMMIT_TOUR_LOCATION_STATE: SummitTourLocationState = {
  showSummitTour: true,
};

export const SHOW_TAKE_A_TOUR_TIP_LOCATION_STATE: SummitTourLocationState = {
  showTakeATourTip: true,
};

export const hasSummitTourLocationState = (state: unknown): boolean =>
  typeof state === "object" &&
  state !== null &&
  (state as SummitTourLocationState).showSummitTour === true;

export const hasTakeATourTipLocationState = (state: unknown): boolean =>
  typeof state === "object" &&
  state !== null &&
  (state as SummitTourLocationState).showTakeATourTip === true;
